import baseService from './baseService'

export const dataServices = {
    getDataForCustomers,
    getSmeDataForFilters,
    getMikroDataForFilters,
    getDataForEditFilters,
    editUserInformation,
    editApplicationStatus,
    scoreCustomer,
    getChartData,
    getLearningResources
}

function getDataForCustomers (data) {
    return baseService.postRequest('/api/secure/result/customer', data)
}

function getSmeDataForFilters() {
    return baseService.getRequest('/api/secure/result/smeDropDownData')
}

function getMikroDataForFilters() {
    return baseService.getRequest('/api/secure/result/mikroDropDownData')
}

function getDataForEditFilters() {
    return baseService.getRequest('/api/secure/result/dropDownDataForEditFilters')
}

function editUserInformation(data) {
    return baseService.postRequest('/api/secure/result/editUserInformation', data)
}

function scoreCustomer(data) {
    return baseService.postRequest('/api/secure/result/scoreCustomer', data)
}

function editApplicationStatus(data) {
    return baseService.postRequest('/api/secure/result/editApplicationStatus', data)
}

function getChartData(data) {
    return baseService.postRequest('/api/secure/result/chartData', data)
}
function getLearningResources () {
    return baseService.getRequest('/api/secure/result/learningResources')
}
